<template>
  <div>
    <b-card>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          Security policy
        </div>
      </div>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_lock_count" v-b-tooltip.hover title="Password Fail Count Threshold, default is 5 on system">
            Password failed Count
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.account_lock_count" :disabled="lock || true" plaintext></b-input>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_lock_time"  v-b-tooltip.hover title="when failed too many logins, default is 5 min on system">
            Block time(Min)
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.account_lock_time" :disabled="lock || true" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_password_min_len" v-b-tooltip.hover title="require min length">
            Password Min length
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.password_min_len" :disabled="lock || true" plaintext></b-input>
        </b-col>
      </b-row>
      <br>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
            Password Use Alphabet
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox disabled" name="Alphabet" id="Alphabet" v-model="group.security_policy.password_use_alphabet" :disabled="lock || true">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_number" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
            Password Use Spacial
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch disabled">
            <input type="checkbox" class="input-checkbox disabled" name="Spacial" id="Spacial" v-model="group.security_policy.password_use_number" :disabled="lock || true">
            <div class="checkbox-animate">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_spacial" v-b-tooltip.hover title="password require Number, ex) 0123456789">
            Password Use Number
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox disabled" name="Number" id="Number" v-model="group.security_policy.password_use_spacial" :disabled="lock || true">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
          <h5 class="text-danger strong">* Allow IP : The settings in the group apply to all accounts in the group</h5>
        </b-col>
      </b-row>
        <ip-list
          type="account"
          comment="The IP Access Control Policy of the Group comes first, followed by the User-specific IP Access Control Policy."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :ip_list="group.allow_ip_account || []"
          :edit="false"
          >
          <!-- @add="ip_add"
          @save="save"
          @remove="ip_remove"
          @clear="ip_clear" -->
        </ip-list>
        <ip-list
          type="agent"
          comment="IP access control is applied when the agent is installed If you don't have one, you can install it anywhere, but we recommend it."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :edit="false"
          :ip_list="group.allow_ip_agent || []"
          >
        </ip-list>
        <!-- @add="ip_add"
        @save="save"
        @remove="ip_remove"
        @clear="ip_clear" -->
      <!-- <template v-if="lock">
        <template>
          <b-button size="sm" variant="primary" @click="edit"> Modify </b-button>
        </template>
      </template>
      <template v-else>
        <b-button size="sm" variant="success" @click="save"> Save </b-button>
        <b-button size="sm" variant="default" @click="cancel"> Cancel </b-button>
      </template> -->
    </b-card>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>